// extracted by mini-css-extract-plugin
module.exports = {"icon":"iconography-moduleicon3sg","iconBaseline":"iconography-moduleiconBaseline2ZL"};